import { IVehicleSearch } from "../../interfaces/VehicleSearch";

export const determineFree = function (vehicle: IVehicleSearch | undefined, noVat: boolean, services: any, reservationLength?: number, couponValid?: boolean, pointsToBeApplied?: number) {
  if(!vehicle || !reservationLength) {
    return false;
  }

  if ((vehicle.onsale || vehicle.privateData?.vip) && (!pointsToBeApplied || pointsToBeApplied <= 0)) {
    return false;
  }

  let pricingDataType = noVat ? vehicle.pricingDataNoVat : vehicle.pricingData;

  if (pricingDataType.withCoupon === null) {
    if (pointsToBeApplied && pointsToBeApplied > 0) {
      let currentPrice = vehicle.onsale ? baseOnSalesDiscountPrice(vehicle, noVat, services, reservationLength) :
          couponValid ? discountPrice(vehicle, noVat, services, reservationLength) : basePrice(vehicle, noVat, services, reservationLength)
      return (currentPrice - pointsToBeApplied) <= 0;
    }
    return false;
  } else {
    let kmPricewithCoupon;
    if (services.kmRange === 0) {
      kmPricewithCoupon = pricingDataType.withCoupon!.unlimitedKilometers / 100;
    } else {
      if (services.kmRange > 100) {
        // additional km over 100 are not part of the discount, so we will use base price
        // should be able to use withCoupon value as well --> this should however be the same as base price
        kmPricewithCoupon = pricingDataType.base.pricePerKilometer / 100 * (services.kmRange - 100);
      } else {
        kmPricewithCoupon = 0;
      }
    }

    let priceAfterDiscount = pricingDataType.withCoupon!.totalPrice / 100 +
      ((services.insurance?.includes('1030') ? pricingDataType.withCoupon!.highDeductible / 100 : 0) +
          (services.insurance?.includes('1028') ? pricingDataType.withCoupon!.lowDeductible / 100 : 0) +
          (services.insurance?.includes('1053') ? pricingDataType.withCoupon!.midDeductible / 100 : 0) +
          (services.windshield ? pricingDataType.withCoupon!.windshieldInsurance / 100 : 0) +
          (services.tireInsurance ? pricingDataType.withCoupon!.tireInsurance / 100 : 0) +
          (services.cancellationInsurance ? pricingDataType.withCoupon?.cancellationInsurance / 100 : 0) +
          (services.additionalDriver ? pricingDataType.withCoupon?.additionalDriver / 100 : 0) +
          (services.export ? pricingDataType.withCoupon?.export / 100 : 0) +
          (services.hook ? pricingDataType.withCoupon?.towHitch / 100 : 0) +
          (services.safeDrivePackage ? pricingDataType.withCoupon?.safeDrivePackage / 100 : 0) +
          (services.co2compensation === '1047' ?  pricingDataType.withCoupon?.hundredTwentyFiveGramsCOTwo! / 100 : 0) +
          (services.co2compensation === '1048' ?  pricingDataType.withCoupon?.fiveHundredGramsCOTwo / 100 : 0) +
          (services.co2compensation === '1049' ?  pricingDataType.withCoupon?.sevenHundredGramsCOTwo / 100 : 0) + kmPricewithCoupon) *
        reservationLength;

    if (pointsToBeApplied) {
      priceAfterDiscount -= pointsToBeApplied;
    }

    return priceAfterDiscount<=0;
  } 
};

export const servicesPriceBase = function (vehicle: IVehicleSearch, noVat: boolean, services: any, reservationLength?: number) {
  let kmPrice;

  if (services === undefined) return 0;

  if (!reservationLength) return 0;

  let pricingDataType = noVat ? vehicle.pricingDataNoVat : vehicle.pricingData;
  
  if (services.kmRange === 0) {
    kmPrice = pricingDataType.base.unlimitedKilometers / 100;
  } else {
    if (services.kmRange > 100) {
      kmPrice = pricingDataType.base.pricePerKilometer / 100 * (services.kmRange - 100);
    } else {
      kmPrice = 0; // this accounts for one-way service (kmRange = 100)
    }
  }
  let price = kmPrice*reservationLength;
  if (services.insurance.includes('1030')) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1030']) {
      price += pricingDataType.base.highDeductible / 100 * vehicle.servicesMaxChargeableDays['1030'];
      services.insuranceReservationLength = vehicle.servicesMaxChargeableDays['1030'];
    } else {
      price += pricingDataType.base.highDeductible / 100 * reservationLength;
      services.insuranceReservationLength = reservationLength;
    }
  } 
  
  if (services.insurance.includes('1028'))  {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1028']) {
      price += pricingDataType.base.lowDeductible / 100 * vehicle.servicesMaxChargeableDays['1028'];
      services.insuranceReservationLength = vehicle.servicesMaxChargeableDays['1028'];
    } else {
      price += pricingDataType.base.lowDeductible / 100 * reservationLength;
      services.insuranceReservationLength = reservationLength;
    }
  }

  if (services.insurance.includes('1053'))  {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1053']) {
      price += pricingDataType.base.midDeductible / 100 * vehicle.servicesMaxChargeableDays['1053'];
      services.insuranceReservationLength = vehicle.servicesMaxChargeableDays['1053'];
    } else {
      price += pricingDataType.base.midDeductible / 100 * reservationLength;
      services.insuranceReservationLength = reservationLength;
    }
  }

  if (services.windshield === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1026']) {
      price += pricingDataType.base.windshieldInsurance / 100 * vehicle.servicesMaxChargeableDays['1026'];
      services.windshieldReservationLength = vehicle.servicesMaxChargeableDays['1026'];
    } else {
      price += pricingDataType.base.windshieldInsurance / 100 * reservationLength;
      services.windshieldReservationLength = reservationLength;
    }
  }
  if (services.tireInsurance === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1038']) {
      price += pricingDataType.base.tireInsurance / 100 * vehicle.servicesMaxChargeableDays['1038'];
      services.tireInsuranceReservationLength = vehicle.servicesMaxChargeableDays['1038'];
    } else {
      price += pricingDataType.base.tireInsurance / 100 * reservationLength;
      services.tireInsuranceReservationLength = reservationLength;
    }
  }
  if (services.cancellationInsurance === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1040']) {
      price += pricingDataType.base.cancellationInsurance / 100 * vehicle.servicesMaxChargeableDays['1040'];
      services.cancellationInsuranceReservationLength = vehicle.servicesMaxChargeableDays['1040'];
    } else {
      price += pricingDataType.base.cancellationInsurance / 100 * reservationLength;
      services.cancellationInsuranceReservationLength = reservationLength;
    }
  }
  if (services.additionalDriver === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1041']) {
      price += pricingDataType.base.additionalDriver / 100 * vehicle.servicesMaxChargeableDays['1041'];
      services.additionalDriverReservationLength = vehicle.servicesMaxChargeableDays['1041'];
    } else {
      price += pricingDataType.base.additionalDriver / 100 * reservationLength;
      services.additionalDriverReservationLength = reservationLength;
    }
  }
  if (services.export === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1023']) {
      price += pricingDataType.base.export / 100 * vehicle.servicesMaxChargeableDays['1023'];
      services.exportReservationLegth = vehicle.servicesMaxChargeableDays['1023'];
    } else {
      price += pricingDataType.base.export / 100 * reservationLength;
      services.exportReservationLegth = reservationLength;
    }
  }
  if (services.hook === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1027']) {
      price += pricingDataType.base.towHitch / 100 * vehicle.servicesMaxChargeableDays['1027'];
      services.hookReservationLength = vehicle.servicesMaxChargeableDays['1027'];
    } else {
      price += pricingDataType.base.towHitch / 100 * reservationLength;
      services.hookReservationLength = reservationLength;
    }
  }

  if (services.safeDrivePackage === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1055']) {
      price += pricingDataType.base.safeDrivePackage / 100 * vehicle.servicesMaxChargeableDays['1055'];
      services.safeDriveReservationLength = vehicle.servicesMaxChargeableDays['1055'];
    } else {
      price += pricingDataType.base.safeDrivePackage / 100 * reservationLength;
      services.safeDriveReservationLength = reservationLength;
    }
  }

  if (services.co2compensation === '1047') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1047']) {
      price += pricingDataType.base.hundredTwentyFiveGramsCOTwo! / 100 * vehicle.servicesMaxChargeableDays['1047'];
      services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1047'];
    } else {
      price += pricingDataType.base.hundredTwentyFiveGramsCOTwo! / 100 * reservationLength;
      services.co2CompensationReservationLength = reservationLength;
    }
  }
  if (services.co2compensation === '1048') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1048']) {
      price += pricingDataType.base.fiveHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1048'];
      services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1048'];
    } else {
      price += pricingDataType.base.fiveHundredGramsCOTwo  / 100 * reservationLength;
      services.co2CompensationReservationLength = reservationLength;
    }
  }
  if (services.co2compensation === '1049') {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1049']) {
      price += pricingDataType.base.sevenHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1049'];
      services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1049'];
    } else {
      price += pricingDataType.base.sevenHundredGramsCOTwo  / 100 * reservationLength;
      services.co2CompensationReservationLength = reservationLength;
    }
  }
  return price;
};

export const servicesPriceDiscount = function (vehicle: IVehicleSearch, noVat: boolean, services: any, reservationLength?: number) {
    if(!services || !reservationLength) return 0;

    let pricingDataType = noVat ? vehicle.pricingDataNoVat : vehicle.pricingData;

    let kmPricewithCoupon;
    if (services.kmRange === 0) {
      kmPricewithCoupon = pricingDataType.withCoupon!.unlimitedKilometers / 100;
    } else {
      if (services.kmRange > 100) {
        // additional km over 100 are not part of the discount, so we will use base price
        kmPricewithCoupon = pricingDataType.base.pricePerKilometer / 100 * (services.kmRange - 100);
      } else {
        kmPricewithCoupon = 0;
      }
    }

    if (kmPricewithCoupon < 0) {
      kmPricewithCoupon = 0;
    }

    let price = kmPricewithCoupon*reservationLength;
    if (services.insurance.includes('1030')) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1030']) {
        price += pricingDataType.withCoupon!.highDeductible / 100 * vehicle.servicesMaxChargeableDays['1030'];
      } else {
        price += pricingDataType.withCoupon!.highDeductible / 100 * reservationLength;
      }
    }

    if (services.insurance.includes('1028'))  {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1028']) {
        price += pricingDataType.withCoupon!.lowDeductible / 100 * vehicle.servicesMaxChargeableDays['1028'];
      } else {
        price += pricingDataType.withCoupon!.lowDeductible / 100 * reservationLength;
      }
    }

    if (services.insurance.includes('1053'))  {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1053']) {
        price += pricingDataType.withCoupon!.midDeductible / 100 * vehicle.servicesMaxChargeableDays['1053'];
      } else {
        price += pricingDataType.withCoupon!.midDeductible / 100 * reservationLength;
      }
    }

    if (services.windshield === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1026']) {
        price += pricingDataType.withCoupon!.windshieldInsurance / 100 * vehicle.servicesMaxChargeableDays['1026'];
      } else {
        price += pricingDataType.withCoupon!.windshieldInsurance / 100 * reservationLength;
      }
    }

    if (services.tireInsurance === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1038']) {
        price += pricingDataType.withCoupon!.tireInsurance / 100 * vehicle.servicesMaxChargeableDays['1038'];
      } else {
        price += pricingDataType.withCoupon!.tireInsurance / 100 * reservationLength;
      }
    }

    if (services.cancellationInsurance === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1040']) {
        price += pricingDataType.withCoupon!.cancellationInsurance / 100 * vehicle.servicesMaxChargeableDays['1040'];
      } else {
        price += pricingDataType.withCoupon!.cancellationInsurance / 100 * reservationLength;
      }
    }
    if (services.additionalDriver === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1041']) {
        price += pricingDataType.withCoupon!.additionalDriver / 100 * vehicle.servicesMaxChargeableDays['1041'];
      } else {
        price += pricingDataType.withCoupon!.additionalDriver / 100 * reservationLength;
      }
    }

    if (services.export === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1023']) {
        price += pricingDataType.withCoupon!.export / 100 * vehicle.servicesMaxChargeableDays['1023'];
      } else {
        price += pricingDataType.withCoupon!.export / 100 * reservationLength;
      }
    }
    if (services.hook === true) {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1027']) {
        price += pricingDataType.withCoupon!.towHitch / 100 * vehicle.servicesMaxChargeableDays['1027'];
      } else {
        price += pricingDataType.withCoupon!.towHitch / 100 * reservationLength;
      }
    }

  if (services.safeDrivePackage === true) {
    if (reservationLength > vehicle.servicesMaxChargeableDays['1055']) {
      price += pricingDataType.withCoupon!.safeDrivePackage / 100 * vehicle.servicesMaxChargeableDays['1055'];
    } else {
      price += pricingDataType.withCoupon!.safeDrivePackage / 100 * reservationLength;
    }
  }

    // co2 compensation now uses withCoupon as BE should return acceptable values
    // if base/coupon values differ --> this is fine for now, ignore any changes in values
    if (services.co2compensation === '1047') {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1047']) {
        price += pricingDataType.withCoupon!.hundredTwentyFiveGramsCOTwo! / 100 * vehicle.servicesMaxChargeableDays['1047'];
        services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1047'];
      } else {
        price += pricingDataType.withCoupon!.hundredTwentyFiveGramsCOTwo! / 100 * reservationLength;
        services.co2CompensationReservationLength = reservationLength;
      }
    }

    if (services.co2compensation === '1048') {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1048']) {
        price += pricingDataType.withCoupon!.fiveHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1048'];
        services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1048'];
      } else {
        price += pricingDataType.withCoupon!.fiveHundredGramsCOTwo  / 100 * reservationLength;
        services.co2CompensationReservationLength = reservationLength;
      }
    }

    if (services.co2compensation === '1049') {
      if (reservationLength > vehicle.servicesMaxChargeableDays['1049']) {
        price += pricingDataType.withCoupon!.sevenHundredGramsCOTwo  / 100 * vehicle.servicesMaxChargeableDays['1049'];
        services.co2CompensationReservationLength = vehicle.servicesMaxChargeableDays['1049'];
      } else {
        price += pricingDataType.withCoupon!.sevenHundredGramsCOTwo  / 100 * reservationLength;
        services.co2CompensationReservationLength = reservationLength;
      }
    }
    return (price); 
};

export const basePrice = function (vehicle: IVehicleSearch, noVat: boolean, services: any = undefined, reservationLength:number|undefined = undefined, pointsToBeApplied?: number): number {
  let pricingDataType = noVat ? vehicle.pricingDataNoVat : vehicle.pricingData;
  if (!pointsToBeApplied) {
    return pricingDataType.base.totalPrice / 100 + servicesPriceBase(vehicle, noVat, services, reservationLength);
  } else {
    let originalBasePrice = pricingDataType.base.totalPrice / 100 + servicesPriceBase(vehicle, noVat, services, reservationLength) - pointsToBeApplied
    return originalBasePrice >= 0 ? originalBasePrice : 0;
  }

};

export const baseOnSalesDiscountPrice = function(vehicle: IVehicleSearch, noVat: boolean, services: any = undefined,
                                                 reservationLength: number | undefined = undefined, pointsInEurosToBeApplied?: number): number {
    if(!vehicle.onsale) throw Error("baseOnSalesDiscountPrice: vehicle.onsale = false"); //this should not happen
    let pricingDataType = noVat ? vehicle.onsale.priceNoVat : vehicle.onsale.price;
    if (!pointsInEurosToBeApplied) {
      return ((pricingDataType*vehicle.onsale.discountmultiplier) / 100) + servicesPriceBase(vehicle, noVat, services, reservationLength);
    } else {
      let finalPrice = ((pricingDataType*vehicle.onsale.discountmultiplier) / 100) + servicesPriceBase(vehicle, noVat, services, reservationLength) - pointsInEurosToBeApplied;
      return finalPrice >= 0 ? finalPrice : 0;
    }
  };

export const baseOnSalesPrice = function(vehicle: IVehicleSearch, noVat: boolean, services: any = undefined,
                                         reservationLength: number | undefined = undefined, pointsInEurosToBeApplied?: number): number {
  if(!vehicle.onsale) throw Error("baseOnSalesPrice: vehicle.onsale = false"); //this shoulndt happen
  let pricingDataType = noVat ? vehicle.onsale.priceNoVat : vehicle.onsale.price;
  if (!pointsInEurosToBeApplied) {
    return (pricingDataType / 100) + servicesPriceBase(vehicle, noVat, services, reservationLength);
  } else {
    let finalPrice = (pricingDataType / 100) + servicesPriceBase(vehicle, noVat, services, reservationLength) - pointsInEurosToBeApplied;
    return finalPrice >= 0 ? finalPrice : 0;
  }
};

export const discountPrice = function (vehicle: IVehicleSearch, noVat: boolean, services: any, reservationLength: number, pointsInEurosToBeApplied?: number) {
  let pricingDataType = noVat ? vehicle.pricingDataNoVat : vehicle.pricingData;
  if (!pricingDataType.withCoupon) {
    throw Error("Coupon is false or invalid")
  }

    if (!pointsInEurosToBeApplied) {
        return pricingDataType.withCoupon!.totalPrice / 100 + servicesPriceDiscount(vehicle, noVat, services, reservationLength);
    } else {
        let finalPrice = pricingDataType.withCoupon!.totalPrice / 100 + servicesPriceDiscount(vehicle, noVat, services, reservationLength) - pointsInEurosToBeApplied;
        return finalPrice >= 0 ? finalPrice : 0;
    }
};

export const discountValue = function (vehicle: IVehicleSearch, noVat: boolean, services: any=undefined,
                                       reservationLength:number|undefined=undefined):number {
  // Note: Discount value & points are unrelated --> while points give a discount to the total price, it works with different rules hence it is not included in this calculation

  if (vehicle.privateData?.vip && vehicle.privateData.private) {
    // if vip vehicle + vip not unlocked with code
    // if vip unblocked, it should work same as any other vehicle
    return 0;
  }

  let pricingDataType = noVat ? vehicle.pricingDataNoVat : vehicle.pricingData;

  let totalDiscountPrice;
  if (pricingDataType.nonMember) {
    if (!pricingDataType.withCoupon) {
      totalDiscountPrice = pricingDataType.nonMember.totalPrice / 100;
      // note: no discount services prices --> service price base is used for both alike but also cancels it
      // from adding then subtracting same figure, so removed form eq
      return (pricingDataType.base.totalPrice / 100) - totalDiscountPrice;
    } else {
      totalDiscountPrice = pricingDataType.withCoupon.totalPrice / 100 + servicesPriceDiscount(vehicle, noVat, services,reservationLength);
      return (pricingDataType.base.totalPrice / 100 + servicesPriceBase(vehicle, noVat, services,reservationLength)) - totalDiscountPrice;
    }
  } else {
    if (!pricingDataType.withCoupon) {
      return 0;
    }
    totalDiscountPrice = pricingDataType.withCoupon.totalPrice / 100 + servicesPriceDiscount(vehicle, noVat, services,reservationLength);
    return (pricingDataType.base.totalPrice / 100 + servicesPriceBase(vehicle, noVat, services,reservationLength)) - totalDiscountPrice;
  }
};
